import { vendor } from './vendor';

import authStorageService from './services/auth.storage.service';
import authService from './services/auth.service';
import authInterceptor from './services/auth.interceptor';
import authTransitionsService from './services/auth.transitions.service';
import auth0ClientFactory from './services/auth0ClientFactory.service';
import auth0Service from './services/auth0.service';
import tokenHandlerService from './services/tokenHandler.service';

const authModule = angular.module('journey-ui.auth', [ ...vendor ])
  .factory('authStorageService', authStorageService)
  .factory('authService', authService)
  .factory('authInterceptor', authInterceptor)
  .factory('authTransitionsService', authTransitionsService)
  .factory('auth0ClientFactory', auth0ClientFactory)
  .factory('auth0Service', auth0Service)
  .factory('tokenHandlerService', tokenHandlerService)

  .config([ '$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('authInterceptor');
  } ])
  .run([ 'authTransitionsService', function(authTransitionsService) {
    authTransitionsService.init();
  } ]);

export default authModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/journey-ui/auth/index.js